import { render, staticRenderFns } from "./WrapperGlobalConfig.vue?vue&type=template&id=082805dc&"
import script from "./WrapperGlobalConfig.vue?vue&type=script&lang=js&"
export * from "./WrapperGlobalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports